import React from 'react';
import './App.css';
import Main from './pages/Main'
import Privacy from './pages/Privacy'
import Layout from './pages/Layout'
import Support from './pages/Support'
import Get from './pages/Get'

import { Routes, Route, HashRouter } from 'react-router-dom';
import { CookieMonster, getAppInsights } from './AppInsights';

import CookieConsent from "react-cookie-consent";

const App = () => {
 
  return (
    <HashRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Main />} />
            <Route path="privacy" element={<Privacy />} />
            <Route path='support' element={<Support />} />
            <Route path='get' element={<Get />} />
            <Route path="*" element={<h1>Not Found</h1>} />
          </Route>
        </Routes>
        <CookieConsent
          location="bottom"
          buttonText="Sure"
          enableDeclineButton={true}
          declineButtonText="No"
          cookieName="insightsTracker"
          style={{ background: "#2B373B" }}
          buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
          expires={150}
          onAccept={()=> {
            CookieMonster.allowed = true;
            getAppInsights().trackEvent({name: "CookiesAccepted"});
          }}

          onDecline={()=> {
            CookieMonster.allowed = false;
            getAppInsights().trackEvent({name: "CookiesDeclined"});
          }}
        >
          This website uses cookies to enhance the user experience.<br />
          <a href="/#privacy" style={{ color: "#f5e042", fontSize:"10px" }}>Learn more</a>
        </CookieConsent>
      </div>
    </HashRouter>
  );
}

export default App;
